// src/assets/icons/chevronDownMiniIcon.tsx

const ChevronDownMiniIcon = (
  <svg
    className="fill-none"
    width="12"
    height="12"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDownMiniIcon;